import { render } from "./ImageText.vue?vue&type=template&id=6646d719"
import script from "./ImageText.vue?vue&type=script&lang=js"
export * from "./ImageText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__